const translations = {
  "en": {
    "No valid content detected": "No valid content detected",
    "Recording failed": "Recording failed",
    "Speech recognition failed": "Speech recognition failed",
    "Voice input is already in use": "Voice input is already in use"
  },
  "zh-tw": {
    "No valid content detected": "未檢測到有效內容",
    "Recording failed": "錄製失敗",
    "Speech recognition failed": "語音辨識失敗",
    "Voice input is already in use": "語音輸入已正在使用中"
  }
};

export default translations;
